<template>
    <div class="mobile-filter">
        <div class="mobile-filter__header">
            <h3>{{ $translate("Ceres::Template.itemFilter") }}</h3>
            <button v-show="selectedFacets && selectedFacets.length > 0"
                    class="mobile-filter__clear-all"
                    @click="clearAllFacets()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-reset"></use>
              </svg> {{ $translate("OD3dprimaV2::Template.categoryResetFiltersMobile") }}
            </button>
            <button class="mobile-filter__close btn btn-link" @click="closeFilter()"></button>
        </div>
        <client-only>
            <od-portal-target class="mobile-filter__height" name="mobile-filter"></od-portal-target>
        </client-only>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'mobile-filter',
    computed: {
        ...mapState({
            selectedFacets: state => state.itemList.selectedFacets
        })
    },
    methods:{
        closeFilter()
        {
            let element = document.querySelector(".mobile-filter")

            if(element !== null) {
                element.classList.remove("open");
                document.querySelector("body").classList.remove("menu-is-visible");
            }
        },
        clearAllFacets()
        {
            this.$store.commit('resetAllSelectedFacets');
            this.$store.dispatch('loadItemList')
        }
    }
};
</script>
